/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import Paragraph from 'elements/Paragraph';
import Image from 'elements/Image';

@inject('windowStore')
@observer
export default class ImageLink extends Component {
  render() {
    const {
      data: {
        alt,
        description,
        url,
        image,
        nofollow,
        blank,
      },
      windowStore,
    } = this.props;

    const imageUrl = typeof image === 'string' ? windowStore.adjustImageSize(image) : windowStore.adjustImageSize(image.url);

    return (
      <div>
        <a href={url} rel={!nofollow ? null : nofollow} target={!blank ? null : blank}>
          <Image
            src={imageUrl}
            alt={alt || image.description}
          />
        </a>
        <Paragraph>
          {description}
        </Paragraph>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageLink/index.jsx